import { Directive, HostListener, Self, Optional } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgControl } from '@angular/forms';
import { ALLOWED_CHARACTERS } from '../../helpers/characters/allowed-characters';

const not_allowed_characters:string[] = []
const not_allowed_characters_input_text:string[] = ["/", "^", "¨", "`"]
const not_allowed_characters_input_email:string[] = ["(", ")", "[", "]", ":", ",", ";", '"', "<", ">", "\\"]
const not_allowed_characters_input_password:string[] = ["^", "¨", "`", "'", "\\", "\n", "\r", "\r\n"] //? dépend de la politique de mot de passe
const not_allowed_characters_input_search:string[] = ["^", "¨", "`", '"', "\\", "\n", "\r", "\r\n"]

@Directive({
  selector: '[input[type="text"], input[type="email"], input[type="password"], input[type="search"], textarea]',
  standalone: true
})
export class InputListenerDirective 
{

  constructor(
    private snackBar: MatSnackBar,
    @Optional() @Self() private ngControl: NgControl,
  ) {}

  updateNgControlValue(value:string)
  {
    // Si il s'agit d'un controle d'un formulaire reactive form, on met à jour la valeur du champ
    if (this.ngControl && this.ngControl.control)
    {
      this.ngControl.control.setValue(value)
      this.ngControl.control.updateValueAndValidity()
      this.ngControl.control.markAsDirty()
      this.ngControl.control.markAsTouched()
    }
  }

  @HostListener('input', ['$event'])
  onChange(event: Event)
  {
    const target = (event.target as HTMLInputElement)

    // const value = target.type == "text"
    // ? this.removeCharacter(target.value, not_allowed_characters_input_text)
    // : target.value

    let value = target.value
    const type = target.type

    if( type == "text" && target?.id != "refDossier" ) 
    {
      value = this.removeCharacter(value, not_allowed_characters_input_text)
    }

    if( type == "email" ) 
    {
      value = this.removeCharacter(value, not_allowed_characters_input_email)
      value = this.allowOnlyOneCharacter(value, "@")
    }

    if( type == "password" ) 
    {
      value = this.removeCharacter(value, not_allowed_characters_input_password)
    }

    if( type == "search" ) 
    {
      value = this.removeCharacter(value, not_allowed_characters_input_search)
    }

    this.updateNgControlValue(value)

    const valueToCheck = value.split("")
    const allowed = valueToCheck.every(value => ALLOWED_CHARACTERS.includes(value))

    if(!allowed)
    {
      const deleted_value = valueToCheck.filter(value => !ALLOWED_CHARACTERS.includes(value))
      deleted_value.map(value => not_allowed_characters.push(value))

      const cleaned_value = this.removeCharacter(value, not_allowed_characters)

      this.updateNgControlValue(cleaned_value)

      target.value = cleaned_value

      this.snackBar.open(`Un caractère non autorisé a été détecté, il ne sera pas pris en compte`, "J'ai compris", {
        duration: 5000,
      })
    }
  }

  removeCharacter(str:string, charactersToRemove: readonly string[])
  {
    if(str.trim() == "" || !str) return str

    charactersToRemove.forEach((characters) => {
      if(not_allowed_characters_input_text.includes(characters))
      {
        str = str.replaceAll(characters, ' ')
      }
      else
      {
        str = str.replaceAll(characters, '')
      }
    })

    return str
  }

  allowOnlyOneCharacter(str:string, char:string)
  {
    const character_count = 1

    if(str.trim() == "" || !str) return str
    if(char.length > character_count) 
    {
      char = char.charAt(0)
      console.log(`char has more than ${character_count} : ${char}`)
    }

    let hasSpecifiedChar = false

    return str.replace(/@/g, () => {
      if(hasSpecifiedChar) return ""

      hasSpecifiedChar = true

      return "@"
    })
  }
}
